import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
    padding: "20px",
  },
  leftSide: {
    padding: "0px 12px",
  },
  rightSide: {
    padding: "0px 12px",
  },
  img: {
    width: "119px",
    height: "150px",
  },

  firstCol: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: {
    color: "#000000",
    fontSize: "24px",
    fontWeight: "bold",
    letterSpacing: 0,
  },
  subTitle: {
    color: "#353535",
    fontSize: "16px",
    fontWeight: "normal",
    letterSpacing: 0,
    margin: "8px 0px",
  },
  description: {
    color: "#353535",
    fontSize: "16px",
    letterSpacing: 0,
  },
  link: {
    color: "#4E4E4E",
    fontSize: "16px",
    letterSpacing: 0,
    textDecoration: "underline",
    textAlign: "end",
    cursor: "pointer",
  },
  boldText: {
    fontWeight: "bold",
  },
  rightSide_mobile: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    flexDirection: "column",
    padding: "0px 12px",
    height: "100%",
  },
  title_mobile: {
    color: "#000000",
    fontSize: "20px",
    fontWeight: 300,
    letterSpacing: 0,
    marginBottom: "25px",
  },
  link_mobile: {
    fontSize: "16px",
    cursor: "pointer",
    textAlign: "end",
  },
  img_mobile: {
    width: "89px",
    height: "137px",
  },

  graphLinkMobile: {
    marginTop: "14px",
  },
}));

export default useStyles;
